import Image from "next/image";
const RiderProfilePhoto = ({
  url,
  riderName,
  height = 480,
  width = 480,
  classNames = ""
}) => {
  if (!url) {
    return <Image src="/images/riders/no-pic.jpg" width={width} height={height} alt={riderName} />;
  }
  return <div style={{
    maxHeight: height,
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center'
  }} data-sentry-component="RiderProfilePhoto" data-sentry-source-file="rider-profile-photo.jsx">
        <Image priority src={url} style={{
      alignSelf: 'center'
    }} alt={riderName} width={width} height={height} className={classNames} data-sentry-element="Image" data-sentry-source-file="rider-profile-photo.jsx" />
    </div>;
};
export default RiderProfilePhoto;